/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const brickwall = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.675 11.076H1.261m13.915-5.152H1.77m6.728 0v5.152m3.272 0 .31 5.151M11.05.773l.308 5.151M5.28 11.076l-.412 5.151M5.897.773l-.309 5.151m-3.818 0L2.179 1.7A1.03 1.03 0 0 1 3.204.773h10.539a1.03 1.03 0 0 1 1.025.927l1.406 14.527H.773L1.77 5.924Z"
    />
  </svg>
)
export default brickwall
